import { z } from 'zod';

/** TipTap document JSON (BR-SO-66). Shape-level validation only. */
export const ReceptionTermSnapshotSchema = z.looseObject({
  type: z.literal('doc'),
  content: z.array(z.unknown()).optional(),
});

export type ReceptionTermSnapshot = z.infer<typeof ReceptionTermSnapshotSchema>;
